<template>
  <div>
    <PageHeader :title="title" :items="items"/>
    <div class="card">
      <div class="card-body">
        <div class="col-sm-12">
          <div class="row">
            <div class="col-sm-6 col-12">
              <PerPageSelector v-model="query.perPage"
                               :available-per-page-options="availablePerPageOptions"
              ></PerPageSelector>
            </div>
            <div class="col-sm-3 offset-lg-3 offset-md-3 offset-sm-3 col-12">
              <DataTableSearch v-model="query.filter"
                               :place-holder="$t('pages.customers.search')">
              </DataTableSearch>
            </div>
          </div>
        </div>
        <div>
          <b-table
              ref="buyerTable"
              striped
              hover
              :empty-text="$t('components.bootstrap_table.empty_text')"
              :empty-filtered-text="$t('components.bootstrap_table.empty_filtered_text')"
              show-empty
              :fields="fields"
              :items="getBuyers"
              :stacked="$store.state.app.isMobile"
              :filter="query.filter"
              :per-page="query.perPage"
              :sort-by="query.sortBy"
              :sort-desc="query.sortDesc"
              :current-page="query.page"
          >

            <template v-slot:cell(buyer_name)="data">
              <checked-data :flag="!!data.item.buyer_name">
                <span>{{ data.item.buyer_name }}</span>
              </checked-data>
            </template>

            <template v-slot:cell(preferred_language)="data">
              <checked-data :flag="!!data.item.preferred_language">
                <h5>
                  <span class="badge badge-soft-warning">{{ data.item.preferred_language }}</span>
                </h5>
              </checked-data>
            </template>

            <template v-slot:cell(order_count)="data">
              <checked-data :flag="!!data.item.order_count">
                <h5>
                  <span class="badge badge-soft-success">{{ data.item.order_count }}</span>
                </h5>
              </checked-data>
            </template>

            <template v-slot:cell(buyer_county)="data">
              <checked-data :flag="!!data.item.buyer_county">
                <span>{{ data.item.buyer_county }}</span>
              </checked-data>
            </template>

            <template v-slot:cell(order)="data">
              <span>
                {{ data.item.order.amazon_order_id }}
              </span>
            </template>

            <template v-slot:cell(order.date)="data">
              <span>
                {{ data.item.order.date | date }}
              </span>
            </template>

          </b-table>
          <div class="row">
            <div class="col-sm">
              <Pagination :meta="buyers.meta"></Pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import queryBuilder from "../../mixins/queryBuilder";
import PerPageSelector from "../../components/PerPageSelector";
import DataTableSearch from "../../components/DataTableSearch";
import BuyerService from "../../Services/Api/BuyerService";

export default {
  components: {DataTableSearch, PerPageSelector},
  page() {
    return {
      title: this.$t('pages.customers.title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
  name: "Customer",
  mixins: [queryBuilder],
  data() {
    return {
      title: this.$t('pages.customers.title'),
      items: [
        {
          text: this.$t('pages.customers.items.first'),
          href: "/",
        },
        {
          text: this.$t('pages.customers.items.second'),
          active: true,
        },
      ],
      fields: [
        {key: 'buyer_name', sortable: true, label: this.$t('pages.customers.fields.name')},
        {key: 'buyer_email', sortable: true, label: this.$t('pages.customers.fields.email')},
        {key: 'buyer_county', sortable: false, label: this.$t('pages.customers.fields.county')},
        {key: 'preferred_language', sortable: false, label: this.$t('pages.customers.fields.preferred_language')},
        {key: 'order', sortable: false, label: this.$t('pages.customers.fields.order')},
        {key: 'order.date', sortable: false, label: this.$t('pages.customers.fields.order_date')},
        {key: 'order_count', sortable: false, label: this.$t('pages.customers.fields.order_count')},
      ],
      buyers: {}
    };
  },
  methods: {
    async getBuyers(params = this.query) {
      this.query = {...this.query, ...params}
      const query = this.buildQuery()
      const {data: buyers} = await BuyerService.all({query})
      this.buyers = buyers
      return buyers.data
    },
  }
};
</script>
<style scoped>
</style>